const RenderError = ({error = '', className: propsClass}) => {
  const className = "text-danger ml-2 text-center " + propsClass
  return (
    <small className={className} hidden={!error}>{error}</small>
  )
}

export default RenderError
